/**
 * AI Configuration Utility
 * Controls the visibility of AI features based on environment variables
 */

/**
 * Check if AI features should be displayed
 * @returns {boolean} True if AI features should be shown, false otherwise
 */
export const shouldShowAI = () => {
  const showAI = process.env.REACT_APP_SHOW_AI;
  return showAI === 'true' || showAI === true;
};

/**
 * Environment configuration for AI features
 */
export const aiConfig = {
  showAI: shouldShowAI(),
  // Add other AI-related config options here if needed
};

export default aiConfig;
